var navigation = {
  createNav(page, routeBack) {
    let route = {path: "", params: []};
    switch (page) {
      case "qualitätssicherung":
        route = {
          path: "/qs",
          params: ["qualitätssicherung"]
        }
        break;
      case "temperaturen":
        route = {
          path: "/qs/temperaturen",
          params: ["qualitätssicherung", "temperaturen"]
        }
        break;
      case "temperatur-log":
        route = {
          path: "",
          params: ["qualitätssicherung", "temperaturen", "temperatur-log"]
        }
        break;
      case "servicelisten":
        route = {
          path: "/qs/servicelisten",
          params: ["qualitätssicherung", "servicelisten"]
        }
        break;
      case "checklisten":
        route = {
          path: "/qs/servicelisten/checklists",
          params: ["qualitätssicherung", "servicelisten", "checklisten"]
        }
        break;
      case "reinigungsnachweise":
        route = {
          path: "/qs/servicelisten/checklists/reinigungsnachweise",
          params: ["qualitätssicherung", "servicelisten", "checklisten", "reinigungsnachweise"]
        }
        break;
      case "reinigungsnachweis":
        route = {
          path: "",
          params: ["qualitätssicherung", "servicelisten", "checklisten", "reinigungsnachweise", "reinigungsnachweis"]
        }
        break;
      case "heissetheke":
        route = {
          path: "/qs/servicelisten/heissetheke",
          params: ["qualitätssicherung", "servicelisten", "heissetheke"]
        }
        break;
      case "orgainvent":
        route = {
          path: "/qs/servicelisten/orgainvent",
          params: ["qualitätssicherung", "servicelisten", "orgainvent"]
        }
        break;
      case "wareneingang":
        route = {
          path: "/qs/servicelisten/wareneingang/temperatur",
          params: ["qualitätssicherung", "servicelisten", "wareneingang"]
        }
        break;
    }
    return route;
  }
};


export default navigation;

